<template>
  <component :is="component" ref="root">
    <slot />
  </component>
</template>

<script>
import Sortable from 'sortablejs';

export default {
  name: 'Sortable',

  props: {
    options: {
      type: Object,
      default() {
        return {};
      },
    },
    component: {
      type: String,
      default: 'div',
    },
  },

  data() {
    return {
      sortable: null,
    };
  },

  mounted() {
    this.sortable = new Sortable(this.$refs.root, {
      animation: 0,
      swapThreshold: 0.5,
      forceFallback: true,
      fallbackTolerance: 10,
      ...this.options,
    });
  },

  beforeUnmount() {
    if (this.sortable) {
      this.sortable.destroy();
    }
  },
};
</script>
